import React , { useEffect} from 'react';
import PropTypes from 'prop-types';
import { Input, InfoCard } from 'app/components';
import { Info } from '@phosphor-icons/react';

const EventAddress = (props) => {
  const {
    showHeader, 
    setFormData, 
    formData,
    error,
    setError,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const { event_address: address } = formData;

  const handleChange = (field) => (event) => {
    if (error?.[`event_address${field}Error`] && event.target.value) setError((prev) => ({ ...prev, [`event_address${field}Error`]: '' })); 
    setFormData({
      ...formData,
      event_address: {
        ...address,
        [field]: event.target.value,
      },
    });
  };

  return (
    <>
      {showHeader && <h1 className="heading-36 mb-9">Confirm the venue address</h1>}
      <div className="flex flex-col gap-7 overflow-auto pr-4">
        <Input
          width="100%"
          required={true}
          label="Venue name"
          value={address.name}
          validationStatus={error?.event_addressnameError && 'error'}
          helpText={error?.event_addressnameError}
          onChange={handleChange('name')}
        />
        <Input
          width="100%"
          label="Street line 1"
          required={true}
          value={address.address_line_1}
          validationStatus={error?.event_addressaddress_line_1Error && 'error'}
          helpText={error?.event_addressaddress_line_1Error}
          onChange={handleChange('address_line_1')}
        />
        <Input
          width="100%"
          label="Street line 2"
          value={address.address_line_2}
          onChange={handleChange('address_line_2')}
        />
        <Input
          width="100%"
          label="City/town"
          required={true}
          value={address.city}
          validationStatus={error?.event_addresscityError && 'error'}
          helpText={error?.event_addresscityError}
          onChange={handleChange('city')}
        />
        <InfoCard
          content="Venue cannot be changed once the ticket sale begins."
          icon={<Info weight="fill"
            size={32} />}
        />
      </div>
    </>
  );
};

EventAddress.propTypes = {
  showHeader: PropTypes.bool,
  setFormData: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
};

EventAddress.defaultProps = {
  showHeader:true,
  setFormData: () => {},
  formData: {},
};

export default EventAddress;
